import { currentLanguage } from "../../../algorithms/storage";
import axios from "../../axiosConfig";

// export const addUser = (data) => {
//   return axios.post("Identity/AddUser", data);
// };

export const getCommunitiesData = (pageNumber = 1, pageSize = 10, token) => {
  return axios.get(`Community/GetAll/${pageNumber}/${pageSize}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getCommunitiesDataWithPermssions = (
  pageNumber = 1,
  pageSize = 10,
  token
) => {
  return axios.get(`Community/GetAllWithPermssions/${pageNumber}/${pageSize}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const addCommunityData = (body, token) => {
  return axios.post(`Community/AddCommunity`, body, {
    headers: {
      "Accept-Language": currentLanguage(),
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};
export const deleteCommunityData = (id, token) => {
  return axios.delete(`Community/DeleteCommunity/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getCommunityData = (id, token) => {
  return axios.get(`Community/GetEditCommunityForm/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const editCommunityData = (body, token) => {
  return axios.put(`Community/UpdateCommunity`, body, {
    headers: {
      "Accept-Language": currentLanguage(),
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};
export const getCommunityMembers = (id, token) => {
  return axios.get(`Community/GetAssignMember/${id}`, {
    headers: {
      "Accept-Language": currentLanguage(),
      Authorization: `Bearer ${token}`,
    },
  });
};

export const assignCommunityMembers = (data, token) => {
  return axios.post(`Community/AssignMember`, data, {
    headers: {
      "Accept-Language": currentLanguage(),
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
};
